import React, { memo } from 'react';
import { Check, DollarSign } from 'lucide-react'
import { lowerCase } from 'lodash';

const Item = ({ id, item, isSelected, onSelect }) => {
  let { pay_today, future_schedule, title, amount_type, percentage } = item || {};

  return (
    <div onClick={() => onSelect(id)}
      className={`flex items-center gap-4 p-4 rounded-xl border-2 transition-all duration-200 cursor-pointer select-none 
        ${isSelected ? 'border-blue-500 bg-blue-50/10'
          : 'border-secondary-200 bg-white hover:border-secondary-300'
        }`}>
      <div className={`p-2 rounded-xl text-blue-600 bg-blue-50`}>
        <DollarSign size={16} />
      </div>

      <div className="flex-1 min-w-0">
        <h4 className="text-xs font-bold text-secondary-950">
          {amount_type === "percentage" ? `${percentage.toFixed(0)}% ${title}` : title}
        </h4>

        {future_schedule && lowerCase(future_schedule) !== "none" &&
          <p className="text-[11px] text-secondary-500 mt-1 leading-relaxed">{future_schedule}</p>
        }
      </div>

      <div className="text-right shrink-0">
        <span className="text-sm font-bold text-secondary-900">${Number(pay_today).toFixed(2)}</span>
      </div>

      <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors 
        ${isSelected ? 'border-blue-500 bg-blue-500 text-white'
          : 'border-secondary-300'
        }`}>
        {isSelected && <Check size={10} className="stroke-[3]" />}
      </div>
    </div>
  )
}

export default memo(Item)
